import React from 'react'
import { Button, Tag } from 'antd'
import { Link } from 'react-router-dom'
import { graphql } from 'react-apollo'
import moment from 'moment'
import _get from 'lodash/get'
import { FormattedMessage } from 'react-intl'
import { inject, observer } from 'mobx-react'
import { compose } from 'recompose'
import leftPad from 'left-pad'
import newOrderMutation from '~/App/graphql/mutations/newOrder.gql'
import localeGet from '~/App/utils/localeGet'
const emsbotTrackingCodeRegex = new RegExp(/^E\S*TH$/)

const trackingLink = ({trackingCode, deliveryCarrier}) => {
  const alphafastLink = 'https://www.alphafast.com/th/track?id='
  const emsbotLink = 'https://emsbot.com/#/?s='
  let href = `${alphafastLink}${trackingCode}`
  let text = 'alpha'
  if (deliveryCarrier) {
    switch (deliveryCarrier) {
      case 'alpha':
        href = `${alphafastLink}${trackingCode}`
        text = `alpha`
        break
      case 'emsbot':
        href = `${emsbotLink}${trackingCode}`
        text = `EMS`
        break
      default:
        href = `${emsbotLink}${trackingCode}`
        text = `EMS`
        break
    }
  } else if (emsbotTrackingCodeRegex.test(trackingCode)) {
    href = `${emsbotLink}${trackingCode}`
    text = `EMS`
  }
  return <span style={{ fontWeight: 'normal', fontFamily: 'initial' }}>
    {`Tracking Code: `}
    <a href={href} target="_blank" style={{textDecoration: 'underline'}}>
      {trackingCode}
    </a>
    {` | ด้วย ${deliveryCarrier || text}`}
  </span>
}
const RegistrationItem = ({ router, newOrder, registration, i18n: { locale } }) => {
  const {
    _id,
    event,
    expireAt,
    expired,
    // amount,
    participants,
    orders,
    messages,
    status,
    // successfulPayment,
    amount,
    // onSubmit,
    registrationType,
    payment
  } = registration
  const hideNumber = _get(event, 'settings.ticket.hideNumber')
  const lottoEnabled = _get(registrationType, 'lotto.enabled') || false
  const handleNewOrder = async () => {
    // const { data: { registration }, router } = this.props
    const eventId = _get(registration, 'eventId')
    const registrationId = _get(registration, '_id')
    const result = await newOrder({
      variables: {
        record: {
          eventId,
          registrationId
        }
      }
    })
    const orderId = _get(result, 'data.newOrder.record._id')
    router.push(`/orders/${orderId}/edit`)
  }

  const handleCanSubmitRun = (participant) => {
    if (!participant) return false
    const runs = _get(participant, 'runs', [])
    let canSubmitRun = false
    participant.tickets.forEach(ticket => {
      const races = _get(ticket, 'ticketType.races', [])
      if (races.length === 0) {
        const race = _get(ticket, 'ticketType.race')
        const vrSettings = _get(race, 'settings.virtualRun') || _get(event, 'settings.virtualRun')
        const vrPeriod = _get(vrSettings, 'period')
        const vrDistanceMode = _get(vrSettings, 'distanceMode')
        const canSubmitRunOneTicket = vrSettings && moment().isBetween(vrPeriod.start, vrPeriod.end) &&
          (vrDistanceMode === 'cumulative' || (vrDistanceMode === 'recent' && runs.length === 0))
        canSubmitRun = canSubmitRun || canSubmitRunOneTicket
      } else {
        races.forEach(race => {
          const vrSettings = _get(race, 'settings.virtualRun')
          const vrPeriod = _get(vrSettings, 'period')
          const vrDistanceMode = _get(vrSettings, 'distanceMode')
          const canSubmitRunOneTicket =
          vrSettings && moment().isBetween(vrPeriod.start, vrPeriod.end) &&
          (vrDistanceMode === 'cumulative' || (vrDistanceMode === 'recent' && runs.filter(r => r.raceId === race._id).length === 0))
          canSubmitRun = canSubmitRun || canSubmitRunOneTicket
        })
      }
    })
    return canSubmitRun
  }

  // const { periods, isRegOpen } = event
  // const currentPeriod = periods.find(period =>
  //   moment().isBetween(period.start, period.end)
  // )
  // const canPay = isRegOpen && currentPeriod
  // const canSubmit = isRegOpen && currentPeriod && currentPeriod.preRegister // || (preRegisterPeriod && moment().isBetween(preRegisterPeriod.start, preRegisterPeriod.end))

  // const $submitButton = (
  //   <Button
  //     type="primary"
  //     size="large"
  //     onClick={() => onSubmit({ registrationId: _id })}
  //     style={{ marginLeft: '18px', float: 'right' }}
  //   >
  //     Submit
  //   </Button>
  // )
  // const $submitDisabledButton = (
  //   <Button
  //     type="primary"
  //     size="large"
  //     disabled
  //     style={{ marginLeft: '18px', float: 'right' }}
  //   >
  //     Submit
  //   </Button>
  // )
  // const $payButton = (
  //   <Link to={`/reg/${_id}/pay`} style={{ marginLeft: '18px', float: 'right' }}>
  //     <Button type="primary" size="large">PAY</Button>
  //   </Link>
  // )
  // const $expiredTag = (
  //   <Tag color="red" style={{ marginLeft: '18px', float: 'right' }}>
  //     Expired
  //   </Tag>
  // )
  // if (false) {
  //   const $actionButton = {
  //     draft: canSubmit ? $submitButton : $submitDisabledButton,
  //     submitted: canPay && (expired ? $expiredTag : $payButton)
  //   }
  //   console.log($actionButton)
  // }
  // $actionButton
  let canSubmitRun = false
  let detectedExtraShirtSize = false
  let wrapperMessages = [...messages]
  const addMessage = ({_id, text}) => { if (detectedExtraShirtSize) wrapperMessages.push({_id, text}) }
  // console.log({ status })
  const $paymentStatus = ({
    paid: <Tag color="green">{_get(payment, 'payAmount')} THB ({
      <FormattedMessage id="paymentStatus.paid" defaultMessag="Paid" />
    })</Tag>,
    payment_verifying: (
      <Tag color="yellow">{_get(amount, 'discounted')} THB ({
        <FormattedMessage id="paymentStatus.verifying" defaultMessag="Pending Verification" />
      })</Tag>
    ),
    accepted: <Tag color="orange" className="status">
      {{
        en: 'accepted',
        zh: 'accepted',
        th: 'ได้สิทธิ์ (accepted)'
      }[locale]}
    </Tag>,
    rejected: <Tag color="orange" className="status">
      {{
        en: 'rejected',
        zh: 'rejected',
        th: 'ไม่ได้สิทธิ์ (rejected)'
      }[locale]}
    </Tag>,
    'submitted': <Tag color="orange">{_get(amount, 'discounted')} THB ({
      <FormattedMessage id="paymentStatus.pending" defaultMessag="Pending Payment" />
    })</Tag>,
    '': <Tag color="orange">{_get(amount, 'discounted')} THB ({
      <FormattedMessage id="paymentStatus.pending" defaultMessag="Pending Payment" />
    })</Tag>
  })[status || '']
  return <div className="historyList" style={{ boxShadow: '0px 1px 4px gainsboro' }}>
    <div className="eventDetail">
      <div>
        <span className="eventTitle">
          <Link to={`/${event.slug}`}>{localeGet(event, 'name', locale)}</Link>
          {' '}
          {registration.testMode && <Tag color="red" style={{
            position: 'relative', bottom: '3px'
          }}>
            Test mode !!!
          </Tag>}
        </span>
      </div>
      <div>
        {{ th: 'ประเภท', en: 'type', zh: 'type' }[locale]}: {localeGet(registrationType, 'name', locale)}
      </div>
      <div className="eventBottomDetailData">
        {{ th: 'สถานะการสมัคร', en: 'status', zh: 'status' }[locale]}:&nbsp;
        {$paymentStatus}
        {status === 'draft' && (
          lottoEnabled
            ? <Tag color="orange">
              <FormattedMessage id="registrationStatus.pending_lotto" defaultMessage="Pending Lotto Results" />
            </Tag>
            : <Tag color="orange">
              <FormattedMessage id="registrationStatus.draft" defaultMessage="Pending Submission" />
            </Tag>
        )}
        {participants.length === 0
          ? <Tag color="red">
            <FormattedMessage id="app.incomplete" defaultMessage="Incomplete" />
          </Tag>
          : ['draft', 'accepted'].includes(status) && expireAt &&
          (expired
            ? <Tag color="red">
              <FormattedMessage id="app.expired" defaultMessage="Expired" />
            </Tag>
            : <Tag color="orange">
              <FormattedMessage id="app.payBeforeDate" defaultMessage="Please pay before {date}" values={{
                date: moment(expireAt).format('Do MMMM HH:mm')
              }} />
            </Tag>
          )
        }
      </div>
      {/* status */}
      {/* $actionButton[status] */}
    </div>
    <div className="eventBottomDetail">
      <div className="eventBottomDetailTitle">
        <FormattedMessage id="app.participants" defaultMessag="Participants" />
      </div>
      <ul>
        {participants.map(participant => {
          const numbers = _get(participant, 'tickets', []).map(t => t.number).filter(n => n)
          const trackingCode = _get(participant, 'tickets', []).map(t => t.trackingCode).filter(n => n)[0]
          const deliveryCarrier = _get(participant, 'tickets', []).map(t => t.deliveryCarrier).filter(n => n)[0]
          if (event.slug === `forest` && status === 'paid') {
            _get(participant, 'tickets', []).forEach(t => {
              const shirtId = _get(t, 'shirtId')
              if (['XXS', '3XL', '3XL-black'].includes(shirtId)) {
                detectedExtraShirtSize = true
              }
            })
          }
          canSubmitRun = canSubmitRun || handleCanSubmitRun(participant)
          return <li key={participant._id} style={{marginBottom: '5px'}}>
            <span>
              {participant.profile.firstName}{' '}
              {participant.profile.lastName}
            </span>
            {!hideNumber && numbers.length > 0 && <span>
              {' '} | <span style={{ fontWeight: 'normal', fontFamily: 'monospace' }}>
              BIB: {numbers.map(number => leftPad(`${number}`, 4, '0')).join(', ')} </span>
            </span>}<br/>
            {trackingCode && trackingLink({trackingCode, deliveryCarrier})}
            {!trackingCode && event.slug === `forest` && status === 'paid' && <span className="sendingItem">
              สถานะการส่งเสื้อ : กำลังแพ็คเสื้อเพื่อเตรียมจัดส่ง
            </span>}
          </li>
        })}
      </ul>
      {orders.length > 0 &&
        <React.Fragment>
          <div>{{ en: 'Extra Orders', zh: 'Extra Orders', th: 'รายการสั่งซื้อสินค้า' }[locale]}</div>
          <ul>
            {orders.map(order =>
              <li key={order._id}>
                {{ en: 'Order Code', zh: 'Order Code', th: 'รหัสคำสั่งซื้อ' }[locale]}&nbsp;
                <Link to={`/orders/${order._id}`}>{order.code}</Link>&nbsp;
                {order.status === 'submitted' && (
                  moment().isBefore(order.expireAt)
                    ? <React.Fragment>
                      <Link to={`/orders/${order._id}/pay`}>
                        <FormattedMessage id="app.pay" defaultMessage="Pay" />
                      </Link>&nbsp;
                      <Tag color="orange">
                        <FormattedMessage id="app.payBeforeDate" defaultMessage="Please pay before {date}" values={{
                          date: moment(order.expireAt).format('Do MMMM HH:mm')
                        }} />
                      </Tag>
                    </React.Fragment>
                    : <Tag color="red">
                      <FormattedMessage id="app.orderExpired" defaultMessage="Order Expired" />
                    </Tag>
                )}
                {order.status === 'paid' && <Tag color="green">
                  <FormattedMessage id="paymentStatus.paid" defaultMessag="Paid" />
                </Tag>}
              </li>
            )}
          </ul>
        </React.Fragment>
      }
      {addMessage({_id: 'extraShirt', text: 'เสื้อ Size พิเศษ "บริษัทผู้ผลิตจะส่งของให้วันจันทร์ จะรีบส่งของออกทันที" ค่ะ ขออภัยในความล่าช้า'})}
      {wrapperMessages.length > 0 && <div className="eventBottomDetailTitle">
        <FormattedMessage id="app.messages" defaultMessag="messages" />
      </div>}
      <ul>
        {wrapperMessages.map(({_id, text}) => {
          return <li key={_id} style={{marginBottom: '5px'}}>
            <span>
              {text}
            </span>
          </li>
        })}
      </ul>
    </div>
    <div style={{ textAlign: 'right' }}>
      {(event.extraProductCount > 0 && orders.length < _get(event, 'settings.registration.maxOrders', 0) && status === 'paid') && <Button size="small" onClick={handleNewOrder}>
        {{ en: 'Shop More Items', zh: 'Shop More Items', th: 'ซื้อสินค้าเพิ่มเติม' }[locale]}
      </Button>}&nbsp;
      { canSubmitRun && <Link to={`/reg/${_id}/preview`} style={{ marginRight: 6 }}>
        <Button className="submitRunPageBtn" size="small">{
          {
            en: 'ส่งผลการวิ่ง',
            zh: 'ส่งผลการวิ่ง',
            th: 'ส่งผลการวิ่ง'
          }[locale]
        }</Button>
      </Link> }

      <Link to={`/${event.slug}/register`} style={{ marginRight: 6 }}>
        <Button size="small">{
          {
            en: 'Register more',
            zh: 'Register more',
            th: 'สมัครเพิ่ม'
          }[locale]
        }</Button>
      </Link>

      {/* event.slug === 'forest' && <Link to={`/reg/${_id}/preview`} style={{ marginRight: 6 }}>
        <Button size="small" type="primary">{
          {
            en: 'Edit',
            th: 'แก้ไขใบสมัคร'
          }[locale]
        }</Button>
      </Link> */}
      <Link to={`/reg/${_id}/preview`}>
        <Button size="small" type="primary">{
          {
            en: 'View',
            zh: 'View',
            th: 'รายละเอียด'
          }[locale]
        }</Button>
      </Link>
    </div>
  </div>
}

export default compose(
  graphql(newOrderMutation, { name: 'newOrder' }),
  inject('i18n'),
  inject('router'),
  observer
)(RegistrationItem)



// WEBPACK FOOTER //
// ./src/App/DashboardPage/Components/RegistrationItem.js